import { render } from "./opinion-bar.vue?vue&type=template&id=0f1a019b&scoped=true"
import script from "./opinion-bar.vue?vue&type=script&lang=js"
export * from "./opinion-bar.vue?vue&type=script&lang=js"

import "./opinion-bar.vue?vue&type=style&index=0&id=0f1a019b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1a019b"]])

export default __exports__